import { styled } from '@mui/material';
import {
    Button,
    Checkbox,
    Divider,
    IconButton,
    RadioGroup,
    ScrollableTableMobileSortFilters,
    Stack,
    Text,
} from 'shell/components';
import { COLUMNS } from './MemberTable';

const MemberFilter = ({ memberFilters, setMemberFilters, sortState, handleSetSortState }) => {
    const checkedFiltersCount = memberFilters.filterKeys.length;

    return (
        <Stack divider={<Divider />} spacing={4}>
            <Stack>
                <IconButton
                    aria-label={'close'}
                    sx={{ alignSelf: 'flex-end' }}
                    kind={'exit'}
                    size={'medium'}
                    variant={'square'}
                    onClick={() => setMemberFilters((current) => ({ ...current, open: false }))}
                />

                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                        Sort By
                    </Text>
                    <Button
                        variant={'tertiary'}
                        onClick={() => {
                            setMemberFilters((current) => ({
                                ...current,
                                filterKeys: [],
                            }));
                            handleSetSortState({ order: 'asc', orderBy: null });
                        }}
                    >
                        Reset All
                    </Button>
                </Stack>
                <Stack>
                    <ScrollableTableMobileSortFilters
                        columns={COLUMNS}
                        sortState={sortState}
                        handleSetSortState={handleSetSortState}
                    />
                </Stack>
            </Stack>
            <Stack>
                <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                    Filters {checkedFiltersCount ? `(${checkedFiltersCount})` : ''}
                </Text>
                <CustomText color={'light'} variant={'p1'}>
                    Role
                </CustomText>
                <CustomStack>
                    <Checkbox
                        checked={memberFilters.filterKeys.includes('instructor')}
                        label={'Staff'}
                        labelPlacement={'start'}
                        onChange={(_, checked) => {
                            setMemberFilters((current) => ({
                                ...current,
                                filterKeys: checked
                                    ? [...current.filterKeys, 'instructor']
                                    : current.filterKeys.filter((key) => key !== 'instructor'),
                            }));
                        }}
                    />
                    <Checkbox
                        checked={memberFilters.filterKeys.includes('student')}
                        label={'Student'}
                        labelPlacement={'start'}
                        onChange={(_, checked) => {
                            setMemberFilters((current) => ({
                                ...current,
                                filterKeys: checked
                                    ? [...current.filterKeys, 'student']
                                    : current.filterKeys.filter((key) => key !== 'student'),
                            }));
                        }}
                    />
                </CustomStack>
            </Stack>
        </Stack>
    );
};

const CustomRadioGroup = styled(RadioGroup)(() => {
    return {
        '& label': {
            justifyContent: 'space-between',
        },
    };
});

const CustomText = styled(Text)(({ theme }) => {
    return {
        margin: theme.spacing(2, 0, 1),
    };
});

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        paddingLeft: theme.spacing(2),
        '& label': {
            justifyContent: 'space-between',
        },
    };
});

export default MemberFilter;
